import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicoService {

  private apiUrl = `${environment.cedaeapp}`;

  constructor(private http: HttpClient) { }

  private createAuthorizedJsonHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  }

  /**
   * @param usuarioId UUID do usuário
   * @param dataInicio Data de início (formato ISO: yyyy-MM-ddTHH:mm:ss) - opcional
   * @param dataFim Data de fim (formato ISO: yyyy-MM-ddTHH:mm:ss) - opcional
   * @param pagina Número da página (padrão 1)
   * @param tamanhoPagina Tamanho da página (padrão 10)
   * @param status
   */
  obterIntervaloPorUsuarioCadastro(
    usuarioId: string,
    dataInicio?: string,
    dataFim?: string,
    pagina: number = 1,
    tamanhoPagina: number = 10,
    status?: string,
    numero?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (dataInicio) params = params.set('dataInicio', dataInicio);
    if (dataFim) params = params.set('dataFim', dataFim);
    if (status) params = params.set('status', status); // <--- ESSA LINHA FALTAVA
    if (numero) params = params.set('Numero', numero);

    const url = `${this.apiUrl}/cadastro/usuario/${usuarioId}/obterintervalo`;
    return this.http.get<any>(url, { params });
  }

  obterCadastroPorId(cadastroId: string): Observable<any> {
    const url = `${this.apiUrl}/cadastro/obterporid/${cadastroId}`;
    return this.http.get(url);
  }

  obterDetalhesporIdJuncao(idJuncao: string): Observable<any> {
    const url = `${this.apiUrl}/buscasdetalhadas/recente-por-idjuncao/${idJuncao}`;
    return this.http.get<any>(url);
  }

  /**
   * Obtém todos os cadastros filtrando por período, status e com paginação.
   * @param dataInicial Data de início (formato ISO: yyyy-MM-ddTHH:mm:ss, opcional)
   * @param dataFinal Data de fim (formato ISO: yyyy-MM-ddTHH:mm:ss, opcional)
   * @param status Status do cadastro (opcional)
   * @param pagina Número da página (opcional)
   * @param tamanhoPagina Tamanho da página (opcional)
   */
  obterTodosCadastro(
    dataInicio?: string,
    dataFim?: string,
    pagina?: number,
    tamanhoPagina?: number,
    status?: string,
    nomeConsumidor?: string,
    cpf?: string,
    cnpj?: string,
    matricula?: string,
    cep?: string,
    logradouro?: string,
    bairro?: string,
    cidade?: string,
    numero?: string,
    estado?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (dataInicio) params = params.set('DataInicio', dataInicio);
    if (dataFim) params = params.set('DataFim', dataFim);
    if (pagina !== undefined) params = params.set('Pagina', pagina.toString());
    if (tamanhoPagina !== undefined) params = params.set('TamanhoPagina', tamanhoPagina.toString());
    if (status) params = params.set('status', status);
    if (nomeConsumidor) params = params.set('NomeConsumidor', nomeConsumidor);
    if (cpf) params = params.set('Cpf', cpf);
    if (cnpj) params = params.set('Cnpj', cnpj);
    if (matricula) params = params.set('Matricula', matricula);
    if (cep) params = params.set('Cep', cep);
    if (logradouro) params = params.set('Logradouro', logradouro);
    if (bairro) params = params.set('Bairro', bairro);
    if (cidade) params = params.set('Cidade', cidade);
    if (estado) params = params.set('Estado', estado);
    if (numero) params = params.set('Numero', numero);

    const url = `${this.apiUrl}/cadastro/obtertodos`;
    return this.http.get<any>(url, { params });
  }

  /**
   * Obtém recadastros paginados por intervalo de datas para um usuário.
   * @param usuarioId UUID do usuário
   * @param dataInicio Data inicial (formato ISO: yyyy-MM-ddTHH:mm:ss)
   * @param dataFim Data final (formato ISO: yyyy-MM-ddTHH:mm:ss)
   * @param pagina Número da página (default = 1)
   * @param tamanhoPagina Quantidade de itens por página (default = 10)
   * @param status Status do recadastro (opcional)
   */
  obterRecadastrosPorIntervalo(
    usuarioId: string,
    dataInicio?: string,
    dataFim?: string,
    pagina: number = 1,
    tamanhoPagina: number = 10,
    status?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (dataInicio) params = params.set('dataInicio', dataInicio);
    if (dataFim) params = params.set('dataFim', dataFim);
    if (status) params = params.set('status', status);

    const url = `${this.apiUrl}/recadastro/usuario/${usuarioId}/obterintervalo`;
    return this.http.get<any>(url, { params });
  }

  obterRecadastroPorId(recadastroId: string): Observable<any> {
    const url = `${this.apiUrl}/recadastro/obterporid/${recadastroId}`;
    return this.http.get<any>(url);
  }

  /**
  * Obtém todos os recadastros com filtros opcionais por período, status e paginação.
  * @param dataInicial Data inicial (formato ISO: yyyy-MM-ddTHH:mm:ss)
  * @param dataFinal Data final (formato ISO: yyyy-MM-ddTHH:mm:ss)
  * @param status Status do recadastro
  * @param pagina Número da página
  * @param tamanhoPagina Tamanho da página
  */
  obterTodosRecadastro(
    dataInicio?: string,
    dataFim?: string,
    pagina?: number,
    tamanhoPagina?: number,
    status?: string,
    nomeConsumidor?: string,
    cpf?: string,
    cnpj?: string,
    matricula?: string,
    cep?: string,
    logradouro?: string,
    bairro?: string,
    cidade?: string,
    numero?: string,
    estado?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (dataInicio) params = params.set('DataInicio', dataInicio);
    if (dataFim) params = params.set('DataFim', dataFim);
    if (pagina !== undefined) params = params.set('Pagina', pagina.toString());
    if (tamanhoPagina !== undefined) params = params.set('TamanhoPagina', tamanhoPagina.toString());
    if (status) params = params.set('status', status);
    if (nomeConsumidor) params = params.set('NomeConsumidor', nomeConsumidor);
    if (cpf) params = params.set('Cpf', cpf);
    if (cnpj) params = params.set('Cnpj', cnpj);
    if (matricula) params = params.set('Matricula', matricula);
    if (cep) params = params.set('Cep', cep);
    if (logradouro) params = params.set('Logradouro', logradouro);
    if (bairro) params = params.set('Bairro', bairro);
    if (cidade) params = params.set('Cidade', cidade);
    if (estado) params = params.set('Estado', estado);
    if (numero) params = params.set('Numero', numero);

    const url = `${this.apiUrl}/recadastro/todos`;
    return this.http.get<any>(url, { params });
  }

  /**
   * Obtém registros detalhados por período para um usuário com paginação.
   * @param usuarioId UUID do usuário (obrigatório)
   * @param dataInicio Data inicial no formato ISO (opcional)
   * @param dataFim Data final no formato ISO (opcional)
   * @param pagina Número da página (opcional)
   * @param tamanhoPagina Quantidade de itens por página (opcional)
   * @param status Status do registro (opcional)
   */
  obterTodosRegistrosPorPeriodo(
    usuarioId: string,
    dataInicio?: string,
    dataFim?: string,
    pagina?: number,
    tamanhoPagina?: number,
    status?: string,
    nomeConsumidor?: string,
    cpf?: string,
    cnpj?: string,
    matricula?: string,
    cep?: string,
    logradouro?: string,
    bairro?: string,
    cidade?: string,
    numero?: string,
    estado?: string,
    statusOS?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (dataInicio) params = params.set('DataInicio', dataInicio);
    if (dataFim) params = params.set('DataFim', dataFim);
    if (pagina !== undefined) params = params.set('Pagina', pagina.toString());
    if (tamanhoPagina !== undefined) params = params.set('TamanhoPagina', tamanhoPagina.toString());
    if (status) params = params.set('status', status);
    if (nomeConsumidor) params = params.set('NomeConsumidor', nomeConsumidor);
    if (cpf) params = params.set('Cpf', cpf);
    if (cnpj) params = params.set('Cnpj', cnpj);
    if (matricula) params = params.set('Matricula', matricula);
    if (cep) params = params.set('Cep', cep);
    if (logradouro) params = params.set('Logradouro', logradouro);
    if (bairro) params = params.set('Bairro', bairro);
    if (cidade) params = params.set('Cidade', cidade);
    if (estado) params = params.set('Estado', estado);
    if (numero) params = params.set('Numero', numero);
    if (statusOS) params = params.set('StatusOS', statusOS);

    const url = `${this.apiUrl}/buscasdetalhadas/usuarios/${usuarioId}/registros-por-periodo`;
    return this.http.get<any>(url, { params });
  }

  /**
   * Obtém todos os registros mais recentes com filtros e paginação
   * @param dataInicio Data inicial no formato ISO (opcional)
   * @param dataFim Data final no formato ISO (opcional)
   * @param pagina Número da página (opcional)
   * @param tamanhoPagina Quantidade de itens por página (opcional)
   * @param status Status do registro (opcional)
   * @param nomeConsumidor Nome do consumidor (opcional)
   * @param cpf 
   * @param numeroOS
   * 
   */
  obterTodos(
    dataInicio?: string,
    dataFim?: string,
    pagina?: number,
    tamanhoPagina?: number,
    status?: string,
    nomeConsumidor?: string,
    cpf?: string,
    cnpj?: string,
    matricula?: string,
    cep?: string,
    logradouro?: string,
    bairro?: string,
    cidade?: string,
    estado?: string,
    numero?: string,
    numeroOS?: string,
    statusOS?: string,
    
  ): Observable<any> {
    let params = new HttpParams();

    if (dataInicio) params = params.set('DataInicio', dataInicio);
    if (dataFim) params = params.set('DataFim', dataFim);
    if (pagina !== undefined) params = params.set('Pagina', pagina.toString());
    if (tamanhoPagina !== undefined) params = params.set('TamanhoPagina', tamanhoPagina.toString());
    if (status) {
      params = params.set('Status', status);
      params = params.set('status', status);
    }
    if (nomeConsumidor) params = params.set('NomeConsumidor', nomeConsumidor);
    if (cpf) params = params.set('Cpf', cpf);
    if (cnpj) params = params.set('Cnpj', cnpj);
    if (matricula) params = params.set('Matricula', matricula);
    if (cep) params = params.set('Cep', cep);
    if (logradouro) params = params.set('Logradouro', logradouro);
    if (bairro) params = params.set('Bairro', bairro);
    if (cidade) params = params.set('Cidade', cidade);
    if (estado) params = params.set('Estado', estado);
    if (numero) {
      params = params.set('Numero', numero);
      params = params.set('numero', numero);
    }
    if (statusOS) {
      params = params.set('StatusOS', statusOS);
      params = params.set('statusOS', statusOS);
    }
    if (numeroOS) {
      params = params.set('NumeroOS', numeroOS);
      params = params.set('numeroOS', numeroOS);
      params = params.set('NumeroOs', numeroOS);
      params = params.set('numero_os', numeroOS);
    }
    const url = `${this.apiUrl}/buscasdetalhadas/todos-mais-recentes`;
    return this.http.get<any>(url, { params });
  }

  /**
   * @param cadastroId UUID do cadastro
   * @param novoStatus Novo status a ser definido
   * @param motivoInvalido motivo (opcional)
   * @param usuarioId id do usuário (opcional) - enviado para API quando presente
   */
  atualizarStatusCadastro(cadastroId: string, novoStatus: string, motivoInvalido?: string, usuarioId?: string): Observable<any> {
    const url = `${this.apiUrl}/cadastro/atualizar-status/${cadastroId}`;

    const body: any = {
      novoStatus: novoStatus
    };

    // incluir usuarioId para API se fornecido (várias chaves por compatibilidade)
    if (usuarioId) {
      body.usuarioId = usuarioId;
      body.adminUsuarioId = usuarioId;
      body._adminUsuarioId = usuarioId;
    }

    // Motivo (variações)
    if (motivoInvalido) {
      body.MotivoInvalidacao = motivoInvalido;
      body.motivoInvalidacao = motivoInvalido;
      body.motivoInvalido = motivoInvalido;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.patch<any>(url, body, { headers });
  }

  /**
   * Atualiza o status de um recadastro.
   * @param recadastroId UUID do recadastro
   * @param novoStatus Novo status a ser definido
   * @param motivoInvalidacao motivo (opcional)
   * @param usuarioId id do usuário (opcional) - enviado para API quando presente
   */
  atualizarStatusRecadastro(recadastroId: string, novoStatus: string, motivoInvalidacao?: string, usuarioId?: string): Observable<any> {
    const url = `${this.apiUrl}/recadastro/atualizar-status/${recadastroId}`;

    const body: any = {
      novoStatus: novoStatus
    };

    if (usuarioId) {
      body.usuarioId = usuarioId;
      body.adminUsuarioId = usuarioId;
      body._adminUsuarioId = usuarioId;
    }

    if (motivoInvalidacao) {
      body.motivoInvalidacao = motivoInvalidacao;
      body.MotivoInvalidacao = motivoInvalidacao;
      body.motivoInvalido = motivoInvalidacao;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.patch<any>(url, body, { headers });
  }

  /**
   * @param cadastroId UUID do cadastro
   * @param motivo motivo da negação (opcional)
   */
  negarCadastro(cadastroId: string, motivo?: string): Observable<any> {
    const url = `${this.apiUrl}/cadastro/${cadastroId}/negar`;
    const body: any = {};
    if (motivo !== undefined && motivo !== null) {
      body.motivo = motivo;
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.patch<any>(url, body, { headers });
  }

  /**
   * @param recadastroId UUID do recadastro
   * @param motivo motivo da negação (opcional)
   */
  negarRecadastro(recadastroId: string, motivo?: string): Observable<any> {
    const url = `${this.apiUrl}/recadastro/${recadastroId}/negar`;
    const body: any = {};
    if (motivo !== undefined && motivo !== null) {
      body.motivo = motivo;
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.patch<any>(url, body, { headers });
  }

  iniciarAnaliseCadastro(cadastroId: string, adminUsuarioId: string, token?: string): Observable<any> {
    if (!cadastroId) {
      throw new Error('cadastroId é obrigatório');
    }
    if (!adminUsuarioId) {
      throw new Error('adminUsuarioId é obrigatório');
    }

    const url = `${this.apiUrl}/cadastro/${cadastroId}/iniciar-analise`;

    const body: any = {
      // enviar apenas uma chave para o id do admin; algumas APIs antigas aceitavam _adminUsuarioId
      adminUsuarioId: adminUsuarioId
    };

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.post<any>(url, body, { headers });
  }

  iniciarAnaliseRecadastro(recadastroId: string, adminUsuarioId: string, token?: string): Observable<any> {
    if (!recadastroId) {
      throw new Error('recadastroId é obrigatório');
    }
    if (!adminUsuarioId) {
      throw new Error('adminUsuarioId é obrigatório');
    }

    const url = `${this.apiUrl}/recadastro/${recadastroId}/iniciar-analise`;

    const body: any = {
      // enviar apenas uma chave para o id do admin; algumas APIs antigas aceitavam _adminUsuarioId
      adminUsuarioId: adminUsuarioId
    };

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.post<any>(url, body, { headers });
  }

  // ===== MÉTODOS PARA VALIDAÇÃO DE CAMPOS =====
  
  /**
   * Obtém todas as validações de campos de um recadastro
   */
  obterValidacoesRecadastro(recadastroId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/recadastros/${recadastroId}/validacoes`, {
      headers: this.createAuthorizedJsonHeaders()
    }).pipe(
      map(items => (items || []).map(item => ({
        ...item,
        validado: this.parseValidado(item?.statusFlag ?? item?.validado)
      })))
    );
  }

  /**
   * Atualiza a validação de um campo específico de recadastro (PATCH)
   */
  atualizarValidacaoCampoRecadastro(
    recadastroId: string, 
    campo: string, 
    validado: boolean, 
    observacao?: string
  ): Observable<any> {
    return this.http.patch<any>(
      `${this.apiUrl}/recadastros/${recadastroId}/validacoes/${campo}`, 
      {
        statusFlag: this.formatValidado(validado),
        observacao: observacao ?? null
      },
      {
        headers: this.createAuthorizedJsonHeaders()
      }
    );
  }

  /**
   * Salva múltiplas validações de campos de recadastro em lote (PUT)
   */
  salvarValidacoesRecadastroBulk(
    recadastroId: string, 
    itens: {campo:string, validado:boolean, observacao?:string}[]
  ): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/recadastros/${recadastroId}/validacoes`, 
      {
        itens: itens.map(i => ({
          campo: i.campo,
          statusFlag: this.formatValidado(i.validado),
          observacao: i.observacao ?? null,
          validadoPor: null,
          validadoEm: null
        }))
      }
    );
  }

  /**
   * Obtém todas as validações de campos de um cadastro
   */
  obterValidacoesCadastro(cadastroId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/cadastros/${cadastroId}/validacoes`, {
      headers: this.createAuthorizedJsonHeaders()
    }).pipe(
      map(items => (items || []).map(item => ({
        ...item,
        validado: this.parseValidado(item?.statusFlag ?? item?.validado)
      })))
    );
  }

  /**
   * Atualiza a validação de um campo específico de cadastro (PATCH)
   */
  atualizarValidacaoCampoCadastro(
    cadastroId: string, 
    campo: string, 
    validado: boolean, 
    observacao?: string
  ): Observable<any> {
    return this.http.patch<any>(
      `${this.apiUrl}/cadastros/${cadastroId}/validacoes/${campo}`, 
      {
        statusFlag: this.formatValidado(validado),
        observacao: observacao ?? null
      },
      {
        headers: this.createAuthorizedJsonHeaders()
      }
    );
  }

  /**
   * Salva múltiplas validações de campos de cadastro em lote (PUT)
   */
  salvarValidacoesCadastroBulk(
    cadastroId: string, 
    itens: {campo:string, validado:boolean, observacao?:string}[]
  ): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/cadastros/${cadastroId}/validacoes`, 
      {
        itens: itens.map(i => ({
          campo: i.campo,
          statusFlag: this.formatValidado(i.validado),
          observacao: i.observacao ?? null
        }))
      }
    );
  }

  /**
   * Atualiza a validação de uma foto de local (PATCH)
   * @param fotoId Id da foto (UUID)
   * @param statusFlag Valor esperado pela API (e.g. 'S' ou 'N' ou outros valores de status)
   * @param observacao Observação opcional
   */
  atualizarValidacaoFoto(fotoId: string, statusFlag: string, observacao?: string): Observable<any> {
    const url = `${this.apiUrl}/fotos/validacoes/cadastro/${fotoId}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body: any = { statusFlag: statusFlag };
    if (observacao !== undefined) body.observacao = observacao ?? null;
    return this.http.patch<any>(url, body, { headers });
  }

  /**
   * Atualiza a validação de uma foto de documento (PATCH)
   * @param fotoDocumentoId Id da foto de documento (UUID)
   * @param statusFlag Valor esperado pela API (e.g. 'S' ou 'N' ou outros valores de status)
   * @param observacao Observação opcional
   */
  atualizarValidacaoFotoDocumento(fotoDocumentoId: string, statusFlag: string, observacao?: string): Observable<any> {
    const url = `${this.apiUrl}/fotos/validacoes/documento/${fotoDocumentoId}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body: any = { statusFlag: statusFlag };
    if (observacao !== undefined) body.observacao = observacao ?? null;
    return this.http.patch<any>(url, body, { headers });
      }

      /**
       * Obtém a validação/flag de uma foto de local (GET)
       * Endpoint: /fotos/validacoes/cadastro/{fotoId}
       */
      obterValidacaoFoto(fotoId: string): Observable<any> {
        const url = `${this.apiUrl}/fotos/validacoes/cadastro/${fotoId}`;
        return this.http.get<any>(url);
      }

      /**
       * Obtém a validação/flag de uma foto de documento (GET)
       * Endpoint: /fotos/validacoes/documento/{fotoDocumentoId}
       */
      obterValidacaoFotoDocumento(fotoDocumentoId: string): Observable<any> {
        const url = `${this.apiUrl}/fotos/validacoes/documento/${fotoDocumentoId}`;
        return this.http.get<any>(url);
      }
  

  // Helper: parse incoming 'validado' values from API (accepts 'S'|'N' or boolean)
  private parseValidado(value: any): boolean {
    if (value === 'S' || value === 's') return true;
    if (value === 'N' || value === 'n') return false;
    return Boolean(value);
  }

  // Helper: format boolean into API expected 'S' / 'N'
  private formatValidado(validado: boolean): string {
    return validado ? 'S' : 'N';
  }
}
